import { escapeRegExp } from './regexp';

export default function parseScoreRisco(
  valor,
  separadorMilhar = '.',
  separadorDecimal = ','
) {
  if (valor === null || valor === undefined || valor === '') return null;

  if (typeof valor === 'number') return valor;

  let texto = String(valor).trim();

  if (separadorMilhar && typeof separadorMilhar === 'string') {
    const milharEscapado = escapeRegExp(separadorMilhar);
    const regexMilhar = new RegExp(milharEscapado, 'g');
    texto = texto.replace(regexMilhar, '');
  }

  if (
    separadorDecimal &&
    typeof separadorDecimal === 'string' &&
    separadorDecimal !== '.'
  ) {
    const decimalEscapado = escapeRegExp(separadorDecimal);
    const regexDecimal = new RegExp(decimalEscapado, 'g');
    texto = texto.replace(regexDecimal, '.');
  }

  const numero = Number(texto);

  return Number.isNaN(numero) ? null : numero;
}